import AdSearchForm from './AdSearchForm';

export default AdSearchForm;



// WEBPACK FOOTER //
// ./src/routes/Admin/AdSearchForm/index.ts